import styled from 'styled-components'

export const CheckBoxWrapper = styled.div`
    input {
        height: 2em;
    }
`
